import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Partenaire } from '../model';
import { DatabaseConnection } from './database-connection';

@Injectable({
  providedIn: 'root',
})

export class PartenaireService {

  end_url = 'partenaire'


  constructor(
    private http : HttpClient,
    private  dbConnection : DatabaseConnection
  ){}

  collaborateurPartenaires(idCouritier : string){
    return this.http.get<Partenaire[]>(this.dbConnection.remoteApiConnection.value +  'collaborateur-partenaire/' + idCouritier)
  }

  changePartenaireState(part : Partenaire){
    return this.http.post<Partenaire>(this.dbConnection.remoteApiConnection.value + 'update-partenaire-state' + '/' + part.id, part)
  }
}
